export const COLORS = Object.freeze({
  Primary: "#0A3981",
  Secondary: "#3C3D37",
  Accent: "#009990",
  Background: "#f5fcde",
  nav_background: "#f5f8ff",
  Active: "#f9b15e",
  Idle: "#bff560",
  Idle2: "#dbf056",
  white: "#ffffff",
  Text: "#f99441",
  bg: "#465456",
  accent2: "#8cdfca",
  c1: "#3b5c60",
  c2: "#95b0b4",
  c3: "#617c7f",
  c4: "#585468",
  c5: "#8a869b",
  c6: "#47917d",
  checkbox: {
    bg_active: "#52c41a",
    bg_disabled: "#b7eb8f",
    border: "#d9d9d9",
    bg_future: "#ffffff",
    bg_unchecked: "#fff1b8",
  },
});
